import {BaseProps} from "../../../infrastructure/models/props/base-props";
import React from "react";
import {Sponsorship} from "../sponsorship/sponsorship";
import {APP} from "../../app/consts";
import {BookmakerViewModel} from "../../../domain/common/bookmaker/models/bookmaker-view-model";
import {AppController} from "../../app/app-controller";
import {AppTerms} from "../../app/app-terms";
import {observer} from "mobx-react";
import {PoweredByStrip} from "./powered-by-strip/powered-by-strip";
import {useBookieClick} from "../../../infrastructure/hooks/useBookieClick";

export class WidgetSponsorshipWrapperProps extends BaseProps {
  shouldRenderSponsorship: Boolean;
  shouldRenderBottomPoweredBy: Boolean;
  shouldRenderSponsorshipPoweredBy: Boolean;
  bookmaker: BookmakerViewModel;
  currentLinkModelName: String;
  screenResolution: String;
  controller: AppController;
  i18n: AppTerms;
  sponsorshipUrl: String;
  poweredByText: String;
  poweredByLink: String;
  showDisclaimer: Boolean;
}

export const WidgetSponsorshipWrapper = observer((props: WidgetSponsorshipWrapperProps) => {
  const betsImpressionParams = {
    bookieId: props.bookmaker?.id,
    bookieName: props.bookmaker?.name,
    //missing source
    //missing sportType
  };

  const {bookieHrefModel, onBookieClick} = useBookieClick(props.controller, {
    urlLink: props.sponsorshipUrl,
    bookieId: props.bookmaker?.id,
    bookieName: props.bookmaker?.name,
    widget: APP.GOOGLE_ANALYTICS.PAGES[props.currentLinkModelName],
    hasOdds: !!props.bookmaker,
    buttonType: APP.ANALYTICS.BUTTON_TYPES_MAPPER.bookie,
    impressionType: APP.ANALYTICS.BETS_IMPRESSION_TYPES.main
  });

  const sponsorshipProps = {
    bookieHrefModel,
    showDisclaimer: props.showDisclaimer,
    bookmaker: props.bookmaker,
    controller: props.controller,
    i18n: props.controller.state.terms,
    clickable: props.sponsorshipUrl,
    poweredByText: props.poweredByText,
    poweredByLink: props.poweredByLink,
    shouldRenderPoweredBy: props.shouldRenderSponsorshipPoweredBy,
    onClick: () => onBookieClick(),
    betsImpressionParams,
  };

  const poweredByStripProps = {
    className: 'sponsorship-powered-by',
    controller: props.controller,
    i18n: props.controller.state.terms,
    title: props.poweredByText,
    link: props.poweredByLink
  }

  return (
    <>
      {
        props.shouldRenderSponsorship ? <Sponsorship {...sponsorshipProps}/> : null
      }
      {props.children}
      {
        props.shouldRenderBottomPoweredBy ? <PoweredByStrip {...poweredByStripProps}/> : null
      }
    </>
  );
});
